const nameToolsGroup = 'nameToolsGroup';
const notaryToolsGroup = 'notaryToolsGroup';

export {
  nameToolsGroup,
  notaryToolsGroup,
};
